(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-static/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-static/assets/javascripts/init.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const useDrawResults = svs.components.tipsen.hooks.useDrawResults;
const _svs$components$sport = svs.components.sportinfo.matchInfoRedux.selectors,
  selectSportEvent = _svs$components$sport.selectSportEvent,
  selectLeagueFromSportEvent = _svs$components$sport.selectLeagueFromSportEvent;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const _svs$components$sport2 = svs.components.sportinfo.common.matchState,
  getIsOngoing = _svs$components$sport2.getIsOngoing,
  getSportInfoMatchState = _svs$components$sport2.getSportInfoMatchState,
  getIsFinished = _svs$components$sport2.getIsFinished;
const getStatusTextBySportEventAndLeague = svs.components.sportinfo.sportConfig.helpers.getStatusTextBySportEventAndLeague;
const statusTexts = svs.components.sportinfo.sportConfig.sports.Default.statusTexts;
const SportEventStatus = svs.components.sport.sportEventCommon.SportEventStatus;
const _svs$components$lbUti = svs.components.lbUtils.useMediaQuery,
  useMediaQuery = _svs$components$lbUti.useMediaQuery,
  breakpoints = _svs$components$lbUti.breakpoints,
  BREAKPOINT_SM = _svs$components$lbUti.BREAKPOINT_SM;
const _React = React,
  useEffect = _React.useEffect,
  useState = _React.useState,
  useRef = _React.useRef,
  useCallback = _React.useCallback,
  useMemo = _React.useMemo;
const MatchResultTypes = svs.components.sport.tipsenShared.constants.MatchResultTypes;
const Result = svs.components.tipsen.couponStatic.Result;
const useGetMatchstatus = svs.components.poolBetting.hooks.useGetMatchstatus;
const getLabelForSportEvent = svs.components.poolBetting.utils.getLabelForSportEvent;
const getMatchStatusClass = sportEventStatus => {
  switch (sportEventStatus) {
    case SportEventStatus.Postponed:
    case SportEventStatus.Cancelled:
      return 'canceled';
    default:
      return getSportInfoMatchState(sportEventStatus);
  }
};
const statusTextsShortToFull = (matchStatus, isSmall) => {
  switch (matchStatus) {
    case statusTexts.Cancelled.short:
      return statusTexts.Cancelled.full;
    case statusTexts.Postponed.short:
      return isSmall ? statusTexts.Postponed.short : statusTexts.Postponed.full;
    default:
      return matchStatus;
  }
};
const Init = _ref => {
  var _currentDrawResult, _getMatchStatusClass;
  let drawEvent = _ref.drawEvent,
    drawNumber = _ref.drawNumber,
    productId = _ref.productId,
    isCompressed = _ref.isCompressed,
    isResultPage = _ref.isResultPage;
  const isExtraSmall = useMediaQuery(breakpoints.down(BREAKPOINT_SM));
  const shouldShowResultText = isResultPage || !(isCompressed && isExtraSmall);
  const _useDrawResults = useDrawResults({
      productId,
      drawNumber
    }),
    data = _useDrawResults.data;
  const _data = _slicedToArray(data, 1),
    currentDrawResult = _data[0];
  const eventNumber = (drawEvent === null || drawEvent === void 0 ? void 0 : drawEvent.eventNumber) || undefined;
  const currentMatchId = (drawEvent === null || drawEvent === void 0 ? void 0 : drawEvent.matchId) || undefined;
  const sportEvent = useSelector(state => selectSportEvent(state, currentMatchId));
  const league = useSelector(state => selectLeagueFromSportEvent(state, currentMatchId));
  const isSmall = useMediaQuery(breakpoints.down(BREAKPOINT_SM));
  const _useState = useState(() => statusTextsShortToFull(getStatusTextBySportEventAndLeague(sportEvent, league), isSmall)),
    _useState2 = _slicedToArray(_useState, 2),
    matchStatusText = _useState2[0],
    setMatchStatusText = _useState2[1];
  const matchStatus = useGetMatchstatus({
    matchId: sportEvent === null || sportEvent === void 0 ? void 0 : sportEvent.matchId,
    matchResultState: currentDrawResult === null || currentDrawResult === void 0 || (_currentDrawResult = currentDrawResult[eventNumber - 1]) === null || _currentDrawResult === void 0 ? void 0 : _currentDrawResult.matchResultState
  });
  const matchLabel = useMemo(() => {
    const currentEventDrawResult = currentDrawResult ? currentDrawResult[eventNumber - 1] : undefined;
    const eventResult = "".concat(currentEventDrawResult === null || currentEventDrawResult === void 0 ? void 0 : currentEventDrawResult.home, " - ").concat(currentEventDrawResult === null || currentEventDrawResult === void 0 ? void 0 : currentEventDrawResult.away);
    return getLabelForSportEvent({
      eventResult,
      eventNumber,
      matchStatus,
      sportEventStatus: sportEvent.sportEventStatus
    });
  }, [currentDrawResult, eventNumber, matchStatus, sportEvent.sportEventStatus]);
  const isFinished = currentDrawResult ? currentDrawResult[eventNumber - 1].matchResultState >= MatchResultTypes.VERIFIED : false;
  const isOngoing = !isFinished && sportEvent ? getIsOngoing(sportEvent.sportEventStatus) || getIsFinished(sportEvent.sportEventStatus) : undefined;
  const stopIntervalFunctionRef = useRef();
  const startTimer = useCallback(() => {
    if (isFinished) {
      setMatchStatusText('FT');
      return;
    }
    setMatchStatusText(statusTextsShortToFull(getStatusTextBySportEventAndLeague(sportEvent, league)));
    if (!isOngoing) {
      return;
    }
    stopIntervalFunctionRef.current = setInterval(() => {
      setMatchStatusText(statusTextsShortToFull(getStatusTextBySportEventAndLeague(sportEvent, league)));
    }, 1000);
  }, [isFinished, isOngoing, league, sportEvent]);
  const handleVisibilityChange = useCallback(() => {
    if (document.hidden) {
      return undefined;
    } else if (stopIntervalFunctionRef.current) {
      clearInterval(stopIntervalFunctionRef.current);
      startTimer();
    }
  }, [startTimer]);
  useEffect(() => {
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [handleVisibilityChange]);
  useEffect(() => {
    startTimer();
    return () => {
      if (stopIntervalFunctionRef.current) {
        clearInterval(stopIntervalFunctionRef.current);
      }
    };
  }, [isOngoing, isFinished, sportEvent, league, startTimer]);
  return React.createElement("div", {
    "aria-label": matchLabel,
    className: "pg_coupon_static__init"
  }, matchStatusText && shouldShowResultText && React.createElement("div", {
    "aria-hidden": true,
    className: "pg_coupon_static__init__text pg_coupon_static__init__text--".concat(isFinished ? 'finished' : (_getMatchStatusClass = getMatchStatusClass(sportEvent.sportEventStatus)) === null || _getMatchStatusClass === void 0 ? void 0 : _getMatchStatusClass.toLowerCase())
  }, matchStatusText), React.createElement(Result, {
    drawEvent: drawEvent,
    drawNumber: drawNumber,
    productId: productId
  }));
};
setGlobal('svs.components.tipsen.couponStatic.Init', Init);

 })(window);